'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCSSFunctionFromTemplate = exports.createDeclarationFromTemplate = exports.createQueryFromTemplate = exports.createQueryMinMaxHeaderFromTemplate = exports.createQueryMaxHeaderFromTemplate = exports.createQueryMinHeaderFromTemplate = undefined;

var _ramda = require('ramda');

var _templates = require('../const/templates');

var _converters = require('./converters');

var _formatting = require('./formatting');

var reduceMaxWidthValue = (0, _converters.adjustNumberWithUnit)((0, _ramda.flip)(_ramda.subtract)(0.01));

var createQueryMinHeaderFromTemplate = exports.createQueryMinHeaderFromTemplate = (0, _formatting.replaceToken)(_templates.QUERY_MIN_TEMPLATE, 'minWidth');

var createQueryMaxHeaderFromTemplate = exports.createQueryMaxHeaderFromTemplate = (0, _ramda.pipe)(reduceMaxWidthValue, (0, _formatting.replaceToken)(_templates.QUERY_MAX_TEMPLATE, 'maxWidth'));

var createQueryMinMaxHeaderFromTemplate = exports.createQueryMinMaxHeaderFromTemplate = (0, _ramda.curry)(function (maxWidth, minWidth) {
  return (0, _formatting.replaceTokens)(_templates.QUERY_MIN_MAX_TEMPLATE, {
    minWidth: minWidth,
    maxWidth: reduceMaxWidthValue(maxWidth)
  });
});

var createQueryFromTemplate = exports.createQueryFromTemplate = (0, _formatting.replaceTokens)(_templates.QUERY_TEMPLATE);

var createDeclarationFromTemplate = exports.createDeclarationFromTemplate = (0, _formatting.replaceTokens)(_templates.DECLARATION_TEMPLATE);

var createCSSFunctionFromTemplate = exports.createCSSFunctionFromTemplate = (0, _formatting.replaceTokens)(_templates.CSS_FUNCTION_TEMPLATE);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/templates.js
// module id = 178
// module chunks = 168707334958949